export const trackRecipientPageview = () => {
  window.dataLayer.push({
    event: 'pageview',
    // biome-ignore lint/style/useNamingConvention: existing error
    destination_url: window.location.pathname,
  });
};
